import React from "react";
import { Grid, Typography } from "../../components";

var SharePlaceholder = function SharePlaceholder() {
  return React.createElement(Grid.Box, {
    style: {
      padding: "2rem 0"
    }
  }, React.createElement(Typography, {
    textAlign: "center"
  }, "UDOST\u0118PNIJ WIDOCZNE WY\u0141\u0104CZNIE NA PORTALU"));
};

export default SharePlaceholder;